import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 bg-white" data-id="element-141">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-142">
        <div className="bg-[#FAF7F2] rounded-3xl p-8 md:p-12 border-2 border-brand-green/20 text-center relative overflow-hidden" data-id="element-143">
          <div className="absolute top-0 left-0 w-full h-1 bg-brand-green" data-id="element-144"></div>

          <ShieldCheck className="w-20 h-20 text-brand-green mx-auto mb-6" data-id="element-145" />

          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1A1A1A] mb-6" data-id="element-146">
            Garantía 7 días sin preguntas
          </h2>

          <p className="text-xl text-gray-700 mb-8 leading-relaxed max-w-2xl mx-auto" data-id="element-147">
            Abrí los 12 Tomos. Revisá los 6 Bonus. Usá los Ebooks Elite en tu
            clase.
            <br data-id="element-148" />
            <br data-id="element-149" />
            Si no es lo que esperabas → 100% de devolución. Sin preguntas. Sin
            formularios. Sin drama.
          </p>

          <div className="inline-block bg-white px-6 py-3 rounded-full border border-gray-200 text-sm font-bold text-gray-500 tracking-widest uppercase" data-id="element-150">
            TASA DE DEVOLUCIONES MENOR AL 2%
          </div>
        </div>
      </div>
    </section>;
}